import {Vue} from "vue-property-decorator";

export const ellipsis20 = function (value: string | undefined): string {
    return ellipsis(value, 20);
}

export const ellipsis100 = function (value: string | undefined): string {
    return ellipsis(value, 100);
}

function ellipsis(value: string | undefined, maxLen: number) {
    if (!value) return "";
    if (value.length <= maxLen) return value;

    return `${value.substring(0, maxLen)}...`;
}

export const ellipsis20Filter = Vue.filter('ellipsis20', ellipsis20);
export const ellipsis100Filter = Vue.filter('ellipsis100', ellipsis100);
